
<template>
  <div>
    <div class="iocop_header">
      <!-- <div class="logo"></div> -->
      <div class="menuBox">
        <!-- <div class="menu" v-if="item.show" :class="item.id === currentMenuId ? 'active' : ''"
          v-for="(item, index) in menu" :key="'topMenu' + index" @click.stop="clickMenu(item, index)">{{ item.name }}
        </div> -->
      </div>
      <div class="message_user">
        <el-dropdown @command="handleClick">
          <div class="user">
            <i class="iconfont icon-user"></i>
            <p class="username">{{ user.Canonical }}</p>
            <i class="el-icon-caret-bottom"></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="logout">
              <p class="dropdown_item_text">退出系统</p>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="page_home">
      <div class="page_home_1">
        <img class="backImg" src="../../assets/images/home/titleBack.png" alt srcset />
        <div class="logoImg">
          <img class="logoImg2" src="../../assets/images/home/logo.png" alt srcset />
        </div>
        <div class="aiot">
          <div class="aiot2">AloT</div>
        </div>
        <div class="titleText">
          <div class="titleText1">智慧教学平台</div>
          <div class="titleText2">ALOT SMART TEACHING PLATFORM</div>
        </div>
      </div>
      <div class="cardBox">
        <div class="A_card">
          <div class="card" v-for="(card, index) in cardList" :key="index" @click="gotoPage(card)">
            <img class="cardImg" :src="card.imgurl" alt />
            <div class="cardText">
              <p class="cardText1">
                <span class="cardText1_1_1">{{ card.titleText.substring(0, card.titleColorIndex) }}</span>
                <span style="color: #17171A;">{{ card.titleText.substring(card.titleColorIndex) }}</span>
              </p>
              <p class="cardText2">{{ card.subTitleEn }}</p>
              <p class="cardText3">{{ card.subTitleCn }}</p>
            </div>
          </div>
        </div>
        <div class="B_card" @click="threeJS_View('三维可视化管理中心')">
          <!-- <img class="card" src="../../assets/images/home/menuImg1.png" alt /> -->
          <div class="cardText1">
            <!-- <div class="cardText1_1">生环&地矿</div> -->
            <div class="cardText1_1">三维可视化管理中心</div>
            <div class="cardText1_2">3D Visual Management Center</div>
          </div>
          <div class="cardText2">集运维服务、数据监管、空间使用情况分析为一体的综合性3D可视化平台</div>
        </div>
      </div>
      <div class="footer">
        <div class="footerFlex" v-for="(footer, index) in footerList" @click="gotoPage(footer)" :key="index">
          <img class="footerFlex_img" :src="footer.imgurl" alt />
          <div class="footerFlex_textFlex">
            <div class="footerFlex_text1">{{ footer.titleText }}</div>
            <div class="footerFlex_text">{{ footer.subTitleEn }}</div>
            <div class="footerFlex_text">{{ footer.subTitleCn }}</div>
          </div>
        </div>
      </div>
      <div style="width: 100px;height: 100px;">
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { removeToken, removeOnlineKey, logout } from '@/assets/js/http.js'
export default {
  data() {
    return {
      timer: null,
      cardList: [],
      user: {},
      footerList: [],
      loading:undefined,
      permissions : []
    }
  },
  computed: {
    
  },
  created() {

    this.loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.1)'
    });

    this.getUserInfo()
    // this.user = JSON.parse(localStorage.getItem("user"))
    // this.cardList[3].path = ``
    // this.getUserAuth()
    this.initCardInfo()


        
        // loading.close();

  },
  mounted() {
  },
  methods: {
    clickMessage() {
      this.clickMenu('news')
    },
    clickMenu(item, index) {
      this.$emit('click', item)
    },
    handleClick(type) {
      if (type === 'logout') {
        logout()
      }
    },
    beforeDestroy() {
      if (this.timer) {
        clearInterval(this.timer)
      }
    },
    threeJS_View(authName) {
      let that = this
      if (this.permissions.indexOf(authName) != -1) {
        this.$router.push('/campus')
      }else{
        that.$message.error('没有对应权限，请确认！');
      }
    },
    gotoPage(pageOption) {
      let that = this
      let linkUrl =  pageOption.linkUrl
      if (linkUrl != '' && this.permissions.indexOf(pageOption.authName) != -1) {
        if (linkUrl.indexOf("http") > -1) {
          window.open(linkUrl)
        } else {
          layer.open({
            type: 2,
            title: false,
            shadeClose: false,
            shade: 0.8,
            area: ['80%', '80%'],
            content: linkUrl // iframe 的 url
          });
        }
      }else{
        that.$message.error('没有对应权限，请确认！');
      }
    },
    getUserInfo() {
      this.$get('/odpsmanage/getact.osp').then(res => {
        // this.getUserAuth()
        this.user = res.data
      }).catch(e => {
        this.$router.push('/login')
      })
    },
    initCardInfo() {
      let that = this
      this.$getSearch({
        tplName: '智慧教学平台配置',
        conds: []
      }).then(res => {
        if (res && res.code == "000000") {
          res['模块配置'].forEach(conf => {
            if (conf.CARDTYPE == '1') {
              let cardOp = {
                imgurl: conf.IMAGEURL,
                authName: conf.AUTHNAME,
                titleText: conf.TITLETEXT,
                titleColorIndex: conf.TITLECOLORINDEX,
                subTitleEn: conf.SUBTITLEEN,
                subTitleCn: conf.SUBTITLECN,
                linkUrl: conf.LINKURL
              }
              that.cardList.push(cardOp)
            } else if (conf.CARDTYPE == '2') {
              let footerOp = {
                imgurl: conf.IMAGEURL,
                authName: conf.AUTHNAME,
                titleText: conf.TITLETEXT,
                subTitleEn: conf.SUBTITLEEN,
                subTitleCn: conf.SUBTITLECN,
                linkUrl: conf.LINKURL
              }
              that.footerList.push(footerOp)
            }
          });

          that.initPermissions()
        }else{
          this.$router.push('/401')
        }
      })
    },
    initPermissions (){
      let that = this
      this.$post(`/odpsmanage/showtree.osp?TreeFile=_self&ShowAll=true&_rtype=text`).then(res => {
        res.data.ODPSNode.forEach(permissionItem => {
          that.permissions.push(permissionItem['@NodeAlias'])
        });
        that.loading.close()
        that.loading = undefined
      }).catch(e=>{
        this.$router.push('/401')
      })
    }
  },
}
</script>
<style scoped lang="stylus">
.iocop_header
  height 48px
  // border-color: #005c99;
  // background-repeat: no-repeat;
  // background-color: #F5F5F5 !important;
  background-color: #4375f4ab !important;
  display flex
  z-index 10
  position: absolute
  width:100vw
  .logo
    width 134px
    height 28px
    background-image url('../../assets/images/home/logo.png')
    background-size 100% 100%
    margin 8px 20px 0 20px
  .menuBox
    display flex
    flex 1
    justify-content center
    .menu
      width 120px
      text-align center
      font-size 14px
      color $c7_7
      line-height 48px
      margin 0 10px
      &:hover
        color $c7
        background-color $c7_1
        cursor pointer
    .active
      color $c7
      font-weight 600
      background-color $c7_1
      position relative
      &:before
        content ''
        display block
        position absolute
        bottom 0
        left 0
        width 100%
        height 4px
        background-color #FF8D1A
  .message_user
    // position: absolute
    padding-right 40px
    display flex
    justify-content flex-end
    &:hover
      .message
        .el-icon-bell
          animation message 1s ease-in-out infinite
    .message
      margin 16px 36px 16px 16px
      .el-icon-bell
        color $c7_8
        font-size 24px
        transform-origin top center
    .user
      margin 4px 16px
      display flex
      .username
        font-size 14px
        line-height 40px
        color $c7
        margin 0 8px 0 16px
      .el-icon-caret-bottom
        line-height 40px
        color: #fff !important
      .icon-user
        font-size 18px
        color $c7_8
        margin-top 8px
.page_home
  width 1440px
  height calc(100vh - 86px)
  margin 0 auto
  user-select none

  .page_home_1
    // height 344px
    // overflow hidden
    .backImg
      width 1440px
      height 366px
  .footer
    display flex
    flex-direction row
    justify-content space-around
    padding 13px 75px
    .footerFlex
      display flex
      flex-direction row
      align-items center
      align-content center
      cursor pointer
      &:hover
        // box-shadow 0 0 10px #bcebff
        position relative
        top -1px
        right 2px
      .footerFlex_img
        width 112px
        height 112px
        margin-bottom 3px
        padding 10px
      .footerFlex_textFlex
        display: flex
        flex-direction: column;
        .footerFlex_text1
          width 220px
          height 24px
          // text-align center
          text-align left
          font-size 12px
          font-family HarmonyOS Sans SC
          font-weight 700
          color #4a4a4b
        .footerFlex_text
          width 220px
          height 24px
          // text-align center
          text-align left
          font-size 12px
          font-family HarmonyOS Sans SC
          font-weight 500
          color #b2b2b7
  .cardBox
    display flex
    padding 18px 54px 0
    .A_card
      width 1008px
      display flex
      flex-direction row
      flex-wrap wrap
      align-content: space-between;
      .card
        display flex
        width: 484px;
        height: 176px;
        margin-right 12px
        // margin-top 18px
        background #F2F4F7
        cursor pointer
        flex-direction row
        align-items center
        justify-content: space-around
        &:hover
          box-shadow 0 0 10px #bcebff
          position relative
          top -1px
          right 2px
        .cardImg
          // width 103px
          // height 103px
          width: 132px;
          height: 148px;
          margin 24px 0 8px 0
        .cardText
          width 228px
          display flex
          flex-direction column
          // align-items center
          align-content center
          height 109px
          font-size 20px
          font-family HarmonyOS Sans SC
          font-weight 600
          // margin-top 30px
          .cardText1
            height 33px
            line-height 33px
            .cardText1_1_1
              color #3D95F8
          .cardText2
            height 16px
            line-height 16px
            font-size 12px
            margin-bottom 14px
            color: #b2b2b7;
          .cardText3
            height 46px
            font-size 16px
            font-weight 400
            line-height 24px
            color #2E2E33
            width: 200px
    .B_card
      width 305px
      height 367px
      // background linear-gradient(180deg, #52A4FF 0%, #2E73FD 100%)
      background url('../../assets/images/home/threeBack.png');
      background-size: 305px 367px
      box-shadow 0px 4px 10px rgba(208, 215, 226, 0.4)
      display flex
      flex-direction column
      align-items center
      cursor pointer
      justify-content: flex-end;
      &:hover
        box-shadow 0 0 10px #bcebff
        position relative
        top -1px
        right 2px
      .card
        margin 22px 0 12px 0
      .cardText1
        .cardText1_1
          text-align center
          width 100%
          height 32px
          font-size 24px
          font-family HarmonyOS Sans SC
          font-weight bold
          color #FFFFFF
        .cardText1_2
          width 100%
          height 16px
          font-size 12px
          font-family Microsoft YaHei UI
          font-weight 400
          line-height 16px
          color #FFFFFF
          text-align center
          margin-bottom 14px
      .cardText2
        width 247px
        height 47px
        font-size 14px
        font-family Microsoft YaHei UI
        font-weight 400
        line-height 21px
        color #FFFFFF
        text-align center
        margin-bottom 23px
  .aiot
    position relative
    top -210px
    left 64px
    .aiot2
      width 107px
      height 42px
      font-size 32px
      font-family HarmonyOS Sans SC
      font-weight 900
      line-height 42px
      color #FFFFFF
      background #3D95F8
      text-align center
      position absolute
  .titleText
    position relative
    top -168px
    left 64px
  .titleText1
    width 538px
    height 73px
    font-size 55px
    font-family HarmonyOS Sans SC
    font-weight bold
    line-height 73px
    color #FFFFFF
    position absolute
  .titleText2
    width 347px
    height 24px
    font-size 18px
    font-family HarmonyOS Sans SC
    font-weight 300
    line-height 84px
    position absolute
    top 40px
    color #FFFFFF
  .logoImg
    position relative
    top -360px
    left 30px
    .logoImg2
      position absolute
      width 250px
      height 60px
      top: 50px
</style> 